import { SyncableSingle } from "shared/state/models/syncable";
import { IValidationSetup } from "shared/api/api";


export const SAVE_VALIDATION_SETUP = 'SAVE_VALIDATION_SETUP';
export const SYNC_DATA_VALIDATIONSETUP = 'SYNC_DATA_VALIDATIONSETUP';

export interface ValidationSetupsState extends SyncableSingle<IValidationSetup> {}
